import LayoutWithSideMenu from '@/layout/layoutWithSideMenu/index.vue'

export const system = {
  path: '/system/',
  name: 'system',
  component: LayoutWithSideMenu,
  meta: {
    title: '系统管理'
  },
  children: [
    {
      path: 'menu',
      name: 'menu',
      component: () => import('@/views/system/menu/index.vue'),
      meta: {
        title: '菜单管理'
      }
    },
    {
      path: 'user-mgmt',
      name: 'user-mgmt',
      component: () => import('@/views/system/user-mgmt'),
      meta: {
        title: '用户管理'
      }
    },
    {
      path: 'office',
      name: 'office',
      component: () => import('@/views/system/office'),
      meta: {
        title: '机构管理'
      }
    },
    {
      path: 'role-mgmt',
      name: 'role-mgmt',
      component: () => import('@/views/system/role-mgmt'),
      meta: {
        title: '角色管理'
      }
    },
    {
      path: 'dict-mgmt',
      name: 'dict-mgmt',
      component: () => import('@/views/system/dict-mgmt'),
      meta: {
        title: '字典管理'
      }
    },
    {
      path: 'dict-mgmt-new',
      name: 'dict-mgmt-new',
      component: () => import('@/views/system/dict-mgmt-new'),
      meta: {
        title: '新字典管理'
      }
    },
    {
      path: 'dict-pub',
      name: 'dict-pub',
      component: () => import('@/views/system/dict-pub'),
      meta: {
        title: '平台字典管理'
      }
    },
    {
      path: 'global-parameters',
      name: 'global-parameters',
      component: () => import('@/views/system/global-parameters'),
      meta: {
        title: '全局配置管理'
      }
    },
    {
      path: 'number-rule',
      name: 'number-rule',
      component: () => import('@/views/system/number-rule'),
      meta: {
        title: '编号规则管理'
      }
    },
    {
      path: 'number-rules-second',
      name: 'number-rules-second',
      component: () => import('@/views/system/number-rules-second'),
      meta: {
        title: '编号管理2'
      }
    },
    {
      path: 'send-notification',
      name: 'send-notification',
      component: () => import('@/views/system/send-notification'),
      meta: {
        title: '发送通知'
      }
    },
    {
      path: 'extend-mgmt',
      name: 'extend-mgmt',
      component: () => import('@/views/system/extend-mgmt'),
      meta: {
        title: '扩展信息管理'
      }
    },
    {
      path: 'user-delete',
      name: 'user-delete',
      component: () => import('@/views/system/user-delete'),
      meta: {
        title: '已删除用户管理'
      }
    },
    {
      path: 'scheduler',
      name: 'scheduler',
      component: () => import('@/views/system/scheduler'),
      meta: {
        title: '定时任务'
      }
    },
    {
      path: 'scheduler-log',
      name: 'scheduler-log',
      component: () => import('@/views/system/scheduler-log'),
      meta: {
        title: '定时任务日志'
      }
    },
    {
      path: 'security-audit',
      name: 'security-audit',
      component: () => import('@/views/system/security-audit'),
      meta: {
        title: '密码等级'
      }
    },
    {
      path: 'gateway-mgmt',
      name: 'gateway-mgmt',
      component: () => import('@/views/system/gateway-mgmt'),
      meta: {
        title: '网关管理'
      }
    },
    {
      path: 'sys-log',
      name: 'sys-log',
      component: () => import('@/views/system/sys-log'),
      meta: {
        title: '日志管理'
      }
    },
    {
      path: 'cache',
      name: 'cache',
      component: () => import('@/views/system/cache'),
      meta: {
        title: '缓存管理'
      }
    },
    {
      path: 'notify-role',
      name: 'notify-role',
      component: () => import('@/views/system/notify-role'),
      meta: {
        title: '通知类型管理'
      }
    }
  ]
}
